module.exports = __webpack_public_path__ + "static/media/social-02.01b24ee6.png";